<mat-card class="card-container"
          [class.selected]="isSelected"
          (click)="selectionEvent.emit(paymentMethod)">
  <span [ngSwitch]="paymentMethod.ZAHLWEG_TYP" class="card-container__logo">
    <ng-container *ngSwitchCase="'S'"><img id="sepa-logo" src="assets/img/sepa-1.svg" alt="SEPA logo" /></ng-container>
    <ng-container *ngSwitchCase="'F'"
      ><img id="invoice-logo" src="assets/img/Invoice-Logo.png" alt="Invoice logo"
    /></ng-container>
    <!--    <ng-container *ngSwitchCase="'paypal'"-->
    <!--      ><img id="paypal-logo" src="assets/img/de-pp-logo-200px.png" alt="PayPal logo"-->
    <!--    /></ng-container>-->
    <!--    <ng-container *ngSwitchCase="'mastercard'"-->
    <!--      ><img id="mastercard-logo" src="assets/img/mc_symbol.svg" alt="Mastercard logo"-->
    <!--    /></ng-container>-->
    <!--    <ng-container *ngSwitchCase="'visa'"-->
    <!--      ><img id="visa-logo" src="assets/img/Visa_2021.svg" alt="Visa logo"-->
    <!--    /></ng-container>-->
  </span>
  <span *ngIf="paymentMethod.ZAHLWEG_TYP === 'F'" class="card-container__payment-method-info">
    <span class="cutoff mat-display-3 smaller">{{ 'ACCOUNT.INVOICE' | translate }}</span>
  </span>
  <span *ngIf="paymentMethod.ZAHLWEG_TYP === 'S'" class="card-container__payment-method-info">
    <span *ngIf="paymentMethod.INHABER" class="cutoff mat-display-3 smaller">{{ paymentMethod.INHABER }}</span
    ><br />
    <span class="cutoff mat-display-3 smaller">{{ paymentMethod.BANKNAME }}</span
    ><br />
    <span class="cutoff mat-display-3 smaller">{{ paymentMethod.IBAN }}</span
    ><br />
    <span class="cutoff mat-display-3 smaller">{{ paymentMethod.BIC }}</span
    ><br />
    <span class="cutoff mat-display-3 smaller">{{ paymentMethod.MANDATS_REFERENZ }}</span>
  </span>
  <!--  <span  class="cutoff mat-subheading-1 text-wrapper">-->
  <!--    <span class="second-line">{{ secondCardLine }}</span>-->
  <!--  </span>-->
  <!--  <div *ngIf="paymentMethod.ZAHLWEG_TYP === 'S'" class="align-right button-wrapper">-->
  <!--    <button (click)="delete()" mat-icon-button class="edit-button">-->
  <!--      <mat-icon>delete</mat-icon>-->
  <!--    </button>-->
  <!--  </div>-->
</mat-card>
